<script>
export default {
    name: 'HeaderImage',
    props: {
        src: { type: String, default: '' },
        offsety: { type: String, default: '' },
        height: { type: String, default: '' },
        kicker: { type: String, default: '' },
    },
    computed: {
        isVisible() {
            return this.$route.query.nav !== 'false'
        },
        markVars() {
            const primary = this.$branding.storeVal('design_color_primary', null)
            const secondary = this.$branding.storeVal('design_color_secondary', null)
            return {
                '--pm-lead': primary || 'var(--red)',
                '--pm-chase': secondary || 'var(--teal)',
            }
        },
    },
}
</script>

<template>
    <div class="pagehead" :class="{ 'pagehead--pic': src }" v-if="isVisible">
        <div class="pagehead__main">
            <p class="pagehead__kick" :style="markVars">
                <span class="pagehead__mark"></span>
                <span class="pagehead__kicktext" v-if="kicker">{{ kicker }}</span>
            </p>
            <slot />
        </div>
        <div class="pagehead__pic" v-if="src" :style="{ backgroundImage: 'url(' + src + ')' }">
            <slot name="pic" />
        </div>
    </div>
</template>

<style lang="scss">
.pagehead {
    padding: 34px var(--page-x) 4px;
}
.pagehead--pic {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
}
.pagehead--pic .pagehead__main {
    min-width: 0;
}
.pagehead__pic {
    flex: none;
    align-self: flex-start;
    width: min(200px, 42vw);
    aspect-ratio: 16 / 9;
    background-size: cover;
    background-position: center;
    border-radius: var(--r-md);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 8px 10px;
    margin-top: 2px;
}
.pagehead__pic::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, transparent 38%, rgba(0, 0, 0, 0.78) 100%);
}
.pagehead__kick {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0 0 12px;
    line-height: 1;
}
.pagehead__mark {
    display: block;
    width: 55px;
    height: 10px;
    flex: none;
    background: linear-gradient(90deg, var(--pm-lead) 0 62%, transparent 62% 72%, var(--pm-chase) 72% 100%);
    transform: skewX(-18deg);
}
.pagehead__kicktext {
    font-family: var(--font-display);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.32em;
    font-size: 13px;
    color: var(--teal);
}
.pagehead h1,
.pagehead .h1 {
    font-family: var(--font-display);
    font-weight: 700;
    font-size: var(--fs-h1);
    line-height: 1.1;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: var(--text-heading);
    margin: 0;
}

@media (max-width: 720px) {
    .pagehead {
        padding: 24px 18px 4px;
    }
    .pagehead__mark {
        width: 41px;
    }
    .pagehead h1,
    .pagehead .h1 {
        font-size: 30px;
    }
}
</style>
